import React from "react";

interface ITextAreaProps {
  reason: string;
  handleReasonChange: (event: any) => void;
  maxLength: number;
  minLength: number;
  dataTestId?: string;
}
const TextArea: React.FC<ITextAreaProps> = (TextAreaProps: ITextAreaProps) => {
  const { reason, handleReasonChange, maxLength, minLength, dataTestId } =
    TextAreaProps;
  return (
    <React.Fragment>
      <textarea
        id="reason"
        className="textarea-reason w-100"
        value={reason}
        maxLength={maxLength}
        minLength={minLength}
        onChange={handleReasonChange}
        data-testid={dataTestId ? dataTestId : ""}
      ></textarea>
      <small data-testid="reason-length" className="form-text text-muted text-right">
        {reason.length}/100
      </small>
    </React.Fragment>
  );
};

export default TextArea;
